<nz-form-item class="label-on-top">
  <nz-form-label [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <input
      nz-input
      type="number"
      [placeholder]="placeholder"
      [formControl]="control"
      [disabled]="isDisabled"
      class="mt-2"
    />
    <i
      *ngIf="showClear && control?.value"
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      (click)="clearInput()"
    ></i>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
